import { FiInfo, FiX } from "react-icons/fi";
import styled from "styled-components";
import { DAVYS_GREY_700, PLUM_PURPLE } from "../colors";
import FlexBox from "../FlexBox";
import { Body2, H6 } from "../Headings";
import { useDispatch } from "react-redux";
import { markTwaAIEventShown } from "../../../Store/Actions/twaAIActions";
import { useEffect } from "react";

const Card = styled.div`
  border: 1px solid ${PLUM_PURPLE[200]};
  border-radius: 12px;
  overflow: hidden;
  background: white;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  background: ${PLUM_PURPLE[100]};
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

const Body = styled(FlexBox)`
  flex-direction: column;
  gap: 8px;
  padding: 1rem 14px;
`;

const ActionButton = styled.button`
  margin-top: 12px;
  align-self: flex-start;

  padding: 0.75rem 1.5rem;
  height: auto;

  border-radius: 999px;
  border: 1px solid #d9d9d9;
  background: white;

  color: #df7a58;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;

  cursor: pointer;

  &:hover {
    background: #fafafa;
  }
`;

const CustomisationCard = ({ onClose, onCustomise }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(markTwaAIEventShown("customization_nudge"));
  }, [dispatch]);

  return (
    <Card>
      <Header>
        <HeaderLeft>
          <FiInfo size={14} color={PLUM_PURPLE[800]} />
          <H6 color={PLUM_PURPLE[800]}>Did you know?</H6>
        </HeaderLeft>

        <CloseButton onClick={onClose}>
          <FiX size={16} color={DAVYS_GREY_700} />
        </CloseButton>
      </Header>

      <Body>
        <Body2>
          You can customise the format & length of summaries? Try it from
          Settings.
        </Body2>

        <ActionButton onClick={onCustomise}>Customise</ActionButton>
      </Body>
    </Card>
  );
};

export default CustomisationCard;
